import { entitySelect } from "../../common/entity";
import { useCodeTests } from "./hooks";

const CodeTestSelect = entitySelect({
  name: "codeTest",
  useEntities: useCodeTests,
});

export default CodeTestSelect;
